/**
 * sm-popup-blackfriday.js · Pop-up « Le Black Friday arrive » · boutique Spider-Man
 * Même moteur que le pop-up d'octobre 2026 (v1.1), déjà éprouvé en ligne.
 *
 * Chargé par sections/sm-popup-blackfriday.liquid, qui fournit :
 *   #smbf-config         les réglages (JSON) : langue, code, dates, délai…
 *   #smbf-form-template  le formulaire d'inscription natif de Shopify (form 'customer')
 *
 * Pour tout le monde, jusqu'à la fin de l'offre (réglage « fin ») ; abonné déjà connu : code direct.
 *   Avant le jour J : code du moment (codeAvant, SPIDEY10 −10 %), appliqué au panier, et teaser du Black Friday.
 *   Du jour J à la fin : code Black Friday (code, BLACKSPIDEY −25 %), appliqué au panier.
 * Compte à rebours en direct : « Black Friday dans … » puis, le jour J, « Fin de l'offre dans … ».
 *
 *   ?smbf=show   affiche le pop-up après 1 s, sans les règles d'affichage (inscription réelle)
 *   ?smbf=test   idem, inscription simulée (jamais sur le thème en ligne)
 *   ?smbf=reset  oublie ce que ce navigateur a mémorisé pour ce pop-up
 */
(function () {
  'use strict';
  if (window.__smbfBooted) return;
  window.__smbfBooted = true;

  var VERSION = '1.1.0';
  var SECTION_ID = 'sm-popup-blackfriday';
  var MIN_AFTER_LOAD = 2500;
  var RETRY_BUSY = 3000;
  var K = {
    got: 'smbf_got',           // code Black Friday déjà obtenu : plus de pop-up
    snooze: 'smbf_snooze',     // fermé : pas de pop-up avant cette date (ms)
    known: 'smbf_known',       // abonné connu (arrivé depuis un e-mail marketing)
    t0: 'smbf_t0',             // début de la visite (sessionStorage)
    shown: 'smbf_shown',       // déjà montré pendant cette visite (sessionStorage)
    pending: 'smbf_pending',   // inscription partie par la page de vérification Shopify
    welcomeSub: 'smpb_sub'     // inscrit par le pop-up de bienvenue
  };
  var EMAIL_RE = /^[^\s@<>(),;:\\[\]]+@[^\s@<>(),;:\\[\]]+\.[a-z\u00a1-\uffff]{2,}$/i;

  /* <T> textes (7 langues) — seul bloc avec des caractères accentués, échappés en \uXXXX à la livraison */
  var T = {
    fr: {
      dialog: 'Black Friday\u00a0: \u221225\u00a0% sur toute la boutique',
      pct: '\u221225\u00a0%',
      sub: 'Black Friday\u00a0\u00b7 du\u00a027 au\u00a030\u00a0novembre',
      eyebrow: 'Le Black Friday est l\u00e0',
      eyebrowAvant: 'Le Black Friday arrive \u00e0 grands pas',
      title: '\u221225\u00a0% sur toute la boutique',
      titleAvant: '\u221210\u00a0% d\u00e8s maintenant',
      text: 'Laisse ton e-mail\u00a0: ton code Black Friday s\u2019affiche tout de suite.',
      textAvant: 'Laisse ton e-mail\u00a0: ton code \u221210\u00a0% s\u2019affiche tout de suite. Et du 27 au 30\u00a0novembre, c\u2019est \u221225\u00a0% sur toute la boutique.',
      label: 'Ton adresse e-mail',
      placeholder: 'Ton adresse e-mail',
      cta: 'Je veux mon code Black Friday',
      ctaAvant: 'Je veux mon code \u221210\u00a0%',
      sending: 'Un instant\u2026',
      decline: 'Non merci',
      legal: 'En t\u2019inscrivant, tu acceptes de recevoir nos e-mails (nouveaut\u00e9s et offres). D\u00e9sinscription en un clic. Offre valable du 27 au 30 novembre 2026 \u00e0 23\u00a0h\u00a059.',
      legalAvant: 'En t\u2019inscrivant, tu acceptes de recevoir nos e-mails (nouveaut\u00e9s et offres). D\u00e9sinscription en un clic. Black Friday\u00a0: \u221225\u00a0% du 27 au 30 novembre 2026 \u00e0 23\u00a0h\u00a059.',
      privacy: 'Politique de confidentialit\u00e9',
      errEmail: 'Cette adresse e-mail n\u2019a pas l\u2019air valide.',
      errNetwork: 'Oups, \u00e7a n\u2019a pas march\u00e9. R\u00e9essaie dans un instant.',
      cdBefore: 'Black Friday dans',
      cdDuring: 'C\u2019est le Black Friday\u202f! Fin de l\u2019offre dans',
      units: ['jours', 'heures', 'min', 'sec'],
      okTitle: 'Ton code Black Friday est pr\u00eat\u202f!',
      okTitleAvant: 'Ton code \u221210\u00a0% est pr\u00eat\u202f!',
      okText: 'Voici ton code de r\u00e9duction\u00a0:',
      knownTitle: 'Tu fais d\u00e9j\u00e0 partie de la toile\u202f!',
      knownText: 'Pas besoin de t\u2019inscrire\u00a0: voici ton code Black Friday.',
      knownTextAvant: 'Pas besoin de t\u2019inscrire\u00a0: voici ton code \u221210\u00a0%.',
      copy: 'Copier',
      copied: 'Copi\u00e9\u202f!',
      okApplied: 'Il est d\u00e9j\u00e0 appliqu\u00e9 \u00e0 ton panier\u00a0: \u221225\u00a0% au paiement.',
      okAppliedAvant: 'Il est d\u00e9j\u00e0 appliqu\u00e9 \u00e0 ton panier\u00a0: \u221210\u00a0% au paiement.',
      okManual: 'Saisis-le au moment du paiement.',
      okGift: '',
      okNote: 'Valable sur toute la boutique du 27 au 30 novembre \u00e0 23\u00a0h\u00a059.',
      okNoteAvant: 'Rendez-vous le 27\u00a0novembre\u00a0: \u221225\u00a0% sur toute la boutique, jusqu\u2019au 30.',
      cont: 'Continuer mes achats',
      close: 'Fermer'
    },
    en: {
      dialog: 'Black Friday: 25% off everything',
      pct: '\u221225%',
      sub: 'Black Friday \u00b7 27\u201330\u00a0November',
      eyebrow: 'Black Friday is here',
      eyebrowAvant: 'Black Friday is almost here',
      title: '25% off everything',
      titleAvant: '10% off right now',
      text: 'Drop your email and get your Black Friday code instantly.',
      textAvant: 'Drop your email and get your 10% code instantly. Then from 27 to 30\u00a0November, it\u2019s 25% off everything.',
      label: 'Your email address',
      placeholder: 'Your email address',
      cta: 'Get my Black Friday code',
      ctaAvant: 'Get my 10% code',
      sending: 'One moment\u2026',
      decline: 'No thanks',
      legal: 'By signing up, you agree to receive our emails (new arrivals and offers). Unsubscribe in one click. Offer valid from 27 to 30 November 2026, 11:59 pm (Paris time).',
      legalAvant: 'By signing up, you agree to receive our emails (new arrivals and offers). Unsubscribe in one click. Black Friday: 25% off from 27 to 30 November 2026, 11:59 pm (Paris time).',
      privacy: 'Privacy policy',
      errEmail: 'This email address doesn\u2019t look valid.',
      errNetwork: 'Oops, that didn\u2019t work. Please try again in a moment.',
      cdBefore: 'Black Friday in',
      cdDuring: 'Black Friday is here! Offer ends in',
      units: ['days', 'hours', 'min', 'sec'],
      okTitle: 'Your Black Friday code is ready!',
      okTitleAvant: 'Your 10% code is ready!',
      okText: 'Here\u2019s your discount code:',
      knownTitle: 'You\u2019re already part of the web!',
      knownText: 'No need to sign up: here\u2019s your Black Friday code.',
      knownTextAvant: 'No need to sign up: here\u2019s your 10% code.',
      copy: 'Copy',
      copied: 'Copied!',
      okApplied: 'It\u2019s already applied to your cart: 25% off at checkout.',
      okAppliedAvant: 'It\u2019s already applied to your cart: 10% off at checkout.',
      okManual: 'Enter it at checkout.',
      okGift: '',
      okNote: 'Valid on everything from 27 to 30 November, 11:59 pm (Paris time).',
      okNoteAvant: 'See you on 27\u00a0November: 25% off everything until the 30th.',
      cont: 'Continue shopping',
      close: 'Close'
    },
    de: {
      dialog: 'Black Friday: 25\u00a0% Rabatt auf alles',
      pct: '\u221225\u00a0%',
      sub: 'Black Friday \u00b7 27.\u2013\u206030.\u00a0November',
      eyebrow: 'Der Black Friday ist da',
      eyebrowAvant: 'Der Black Friday steht vor der T\u00fcr',
      title: '\u221225\u00a0% auf alles',
      titleAvant: '\u221210\u00a0% ab sofort',
      text: 'Gib deine E-Mail-Adresse ein und erhalte deinen Black-Friday-Code sofort.',
      textAvant: 'Gib deine E-Mail-Adresse ein und erhalte sofort deinen Code f\u00fcr 10\u00a0% Rabatt. Vom 27. bis 30.\u00a0November gibt es dann \u221225\u00a0% auf alles.',
      label: 'Deine E-Mail-Adresse',
      placeholder: 'Deine E-Mail-Adresse',
      cta: 'Black-Friday-Code sichern',
      ctaAvant: 'Jetzt 10\u00a0% sichern',
      sending: 'Einen Moment \u2026',
      decline: 'Nein, danke',
      legal: 'Mit deiner Anmeldung stimmst du zu, unsere E-Mails (Neuheiten und Angebote) zu erhalten. Abmeldung mit einem Klick. Angebot g\u00fcltig vom 27. bis 30. November 2026, 23:59 Uhr.',
      legalAvant: 'Mit deiner Anmeldung stimmst du zu, unsere E-Mails (Neuheiten und Angebote) zu erhalten. Abmeldung mit einem Klick. Black Friday: \u221225\u00a0% vom 27. bis 30. November 2026, 23:59 Uhr.',
      privacy: 'Datenschutzerkl\u00e4rung',
      errEmail: 'Diese E-Mail-Adresse scheint ung\u00fcltig zu sein.',
      errNetwork: 'Hoppla, das hat nicht geklappt. Bitte versuche es gleich noch einmal.',
      cdBefore: 'Black Friday startet in',
      cdDuring: 'Es ist Black Friday! Angebot endet in',
      units: ['Tage', 'Std.', 'Min.', 'Sek.'],
      okTitle: 'Dein Black-Friday-Code ist bereit!',
      okTitleAvant: 'Dein Rabattcode ist bereit!',
      okText: 'Hier ist dein Rabattcode:',
      knownTitle: 'Du bist schon Teil des Netzes!',
      knownText: 'Keine Anmeldung n\u00f6tig: Hier ist dein Black-Friday-Code.',
      knownTextAvant: 'Keine Anmeldung n\u00f6tig: Hier ist dein Rabattcode.',
      copy: 'Kopieren',
      copied: 'Kopiert!',
      okApplied: 'Er ist bereits in deinem Warenkorb aktiv: \u221225\u00a0% an der Kasse.',
      okAppliedAvant: 'Er ist bereits in deinem Warenkorb aktiv: \u221210\u00a0% an der Kasse.',
      okManual: 'Gib ihn an der Kasse ein.',
      okGift: '',
      okNote: 'G\u00fcltig im ganzen Shop vom 27. bis 30. November, 23:59 Uhr.',
      okNoteAvant: 'Merk dir den 27.\u00a0November: \u221225\u00a0% auf alles, bis zum 30.',
      cont: 'Weiter einkaufen',
      close: 'Schlie\u00dfen'
    },
    nl: {
      dialog: 'Black Friday: 25% korting op alles',
      pct: '\u221225%',
      sub: 'Black Friday \u00b7 27 t/m 30\u00a0november',
      eyebrow: 'Black Friday is begonnen',
      eyebrowAvant: 'Black Friday komt eraan',
      title: '\u221225% op alles',
      titleAvant: 'Nu al \u221210% korting',
      text: 'Laat je e-mailadres achter: je krijgt je Black Friday-code meteen.',
      textAvant: 'Laat je e-mailadres achter: je krijgt meteen je code voor 10% korting. En van 27 t/m 30\u00a0november is het \u221225% op alles.',
      label: 'Je e-mailadres',
      placeholder: 'Je e-mailadres',
      cta: 'Claim mijn Black Friday-code',
      ctaAvant: 'Claim mijn 10% korting',
      sending: 'Even geduld\u2026',
      decline: 'Nee, bedankt',
      legal: 'Door je in te schrijven ga je akkoord met het ontvangen van onze e-mails (nieuwtjes en aanbiedingen). Uitschrijven met \u00e9\u00e9n klik. Actie geldig van 27 t/m 30 november 2026, 23.59 uur.',
      legalAvant: 'Door je in te schrijven ga je akkoord met het ontvangen van onze e-mails (nieuwtjes en aanbiedingen). Uitschrijven met \u00e9\u00e9n klik. Black Friday: \u221225% op alles, geldig van 27 t/m 30 november 2026, 23.59 uur.',
      privacy: 'Privacybeleid',
      errEmail: 'Dit e-mailadres lijkt niet geldig.',
      errNetwork: 'Oeps, dat is niet gelukt. Probeer het zo meteen opnieuw.',
      cdBefore: 'Black Friday begint over',
      cdDuring: 'Het is Black Friday! Actie eindigt over',
      units: ['dagen', 'uur', 'min', 'sec'],
      okTitle: 'Je Black Friday-code is klaar!',
      okTitleAvant: 'Je kortingscode is klaar!',
      okText: 'Hier is je kortingscode:',
      knownTitle: 'Je hoort al bij het web!',
      knownText: 'Inschrijven hoeft niet: hier is je Black Friday-code.',
      knownTextAvant: 'Inschrijven hoeft niet: hier is je kortingscode.',
      copy: 'Kopi\u00ebren',
      copied: 'Gekopieerd!',
      okApplied: 'Hij is al toegepast op je winkelwagen: \u221225% bij het afrekenen.',
      okAppliedAvant: 'Hij is al toegepast op je winkelwagen: \u221210% bij het afrekenen.',
      okManual: 'Vul hem in bij het afrekenen.',
      okGift: '',
      okNote: 'Geldig in de hele winkel van 27 t/m 30 november, 23.59 uur.',
      okNoteAvant: 'Noteer 27\u00a0november: \u221225% op alles, t/m 30\u00a0november.',
      cont: 'Verder winkelen',
      close: 'Sluiten'
    },
    it: {
      dialog: 'Black Friday: 25% di sconto su tutto',
      pct: '\u221225%',
      sub: 'Black Friday \u00b7 dal 27 al 30\u00a0novembre',
      eyebrow: 'Il Black Friday \u00e8 iniziato',
      eyebrowAvant: 'Il Black Friday sta arrivando',
      title: '\u221225% su tutto il negozio',
      titleAvant: '\u221210% da subito',
      text: 'Lascia la tua email: il tuo codice Black Friday appare subito.',
      textAvant: 'Lascia la tua email: il tuo codice sconto del 10% appare subito. E dal 27 al 30\u00a0novembre arriva il \u221225% su tutto il negozio.',
      label: 'Il tuo indirizzo email',
      placeholder: 'Il tuo indirizzo email',
      cta: 'Voglio il codice Black Friday',
      ctaAvant: 'Voglio il mio 10% di sconto',
      sending: 'Un attimo\u2026',
      decline: 'No, grazie',
      legal: 'Iscrivendoti accetti di ricevere le nostre email (novit\u00e0 e offerte). Disiscrizione con un clic. Offerta valida dal 27 al 30 novembre 2026 alle 23:59.',
      legalAvant: 'Iscrivendoti accetti di ricevere le nostre email (novit\u00e0 e offerte). Disiscrizione con un clic. Black Friday: \u221225% dal 27 al 30 novembre 2026 alle 23:59.',
      privacy: 'Informativa sulla privacy',
      errEmail: 'Questo indirizzo email non sembra valido.',
      errNetwork: 'Ops, qualcosa non ha funzionato. Riprova tra un attimo.',
      cdBefore: 'Black Friday tra',
      cdDuring: '\u00c8 Black Friday! L\u2019offerta termina tra',
      units: ['giorni', 'ore', 'min', 'sec'],
      okTitle: 'Il tuo codice Black Friday \u00e8 pronto!',
      okTitleAvant: 'Il tuo codice sconto \u00e8 pronto!',
      okText: 'Ecco il tuo codice sconto:',
      knownTitle: 'Fai gi\u00e0 parte della ragnatela!',
      knownText: 'Non serve iscriverti: ecco il tuo codice Black Friday.',
      knownTextAvant: 'Non serve iscriverti: ecco il tuo codice sconto.',
      copy: 'Copia',
      copied: 'Copiato!',
      okApplied: '\u00c8 gi\u00e0 applicato al tuo carrello: \u221225% al pagamento.',
      okAppliedAvant: '\u00c8 gi\u00e0 applicato al tuo carrello: \u221210% al pagamento.',
      okManual: 'Inseriscilo al momento del pagamento.',
      okGift: '',
      okNote: 'Valido su tutto il negozio dal 27 al 30 novembre alle 23:59.',
      okNoteAvant: 'Segnati il 27\u00a0novembre: \u221225% su tutto il negozio fino al 30.',
      cont: 'Continua lo shopping',
      close: 'Chiudi'
    },
    es: {
      dialog: 'Black Friday: 25\u00a0% de descuento en todo',
      pct: '\u221225\u00a0%',
      sub: 'Black Friday \u00b7 del 27 al 30 de\u00a0noviembre',
      eyebrow: 'Ya est\u00e1 aqu\u00ed el Black Friday',
      eyebrowAvant: 'Llega el Black Friday',
      title: '\u221225\u00a0% en toda la tienda',
      titleAvant: '\u221210\u00a0% desde ya',
      text: 'D\u00e9janos tu correo y consigue al instante tu c\u00f3digo del Black Friday.',
      textAvant: 'D\u00e9janos tu correo y consigue al instante tu c\u00f3digo de descuento del 10\u00a0%. Y del 27 al 30 de\u00a0noviembre, \u221225\u00a0% en toda la tienda.',
      label: 'Tu correo electr\u00f3nico',
      placeholder: 'Tu correo electr\u00f3nico',
      cta: 'Quiero mi c\u00f3digo del Black Friday',
      ctaAvant: 'Quiero mi 10\u00a0% de descuento',
      sending: 'Un momento\u2026',
      decline: 'No, gracias',
      legal: 'Al suscribirte, aceptas recibir nuestros correos (novedades y ofertas). Puedes darte de baja con un clic. Oferta v\u00e1lida del 27 al 30 de noviembre de 2026, hasta las 23:59.',
      legalAvant: 'Al suscribirte, aceptas recibir nuestros correos (novedades y ofertas). Puedes darte de baja con un clic. Black Friday: \u221225\u00a0% del 27 al 30 de noviembre de 2026, hasta las 23:59.',
      privacy: 'Pol\u00edtica de privacidad',
      errEmail: 'Esta direcci\u00f3n de correo no parece v\u00e1lida.',
      errNetwork: 'Vaya, algo ha fallado. Int\u00e9ntalo de nuevo en un momento.',
      cdBefore: 'Black Friday en',
      cdDuring: '\u00a1Es Black Friday! La oferta termina en',
      units: ['d\u00edas', 'horas', 'min', 'seg'],
      okTitle: '\u00a1Tu c\u00f3digo del Black Friday est\u00e1 listo!',
      okTitleAvant: '\u00a1Tu c\u00f3digo de descuento est\u00e1 listo!',
      okText: 'Aqu\u00ed tienes tu c\u00f3digo de descuento:',
      knownTitle: '\u00a1Ya formas parte de la telara\u00f1a!',
      knownText: 'No hace falta suscribirte: aqu\u00ed tienes tu c\u00f3digo del Black Friday.',
      knownTextAvant: 'No hace falta suscribirte: aqu\u00ed tienes tu c\u00f3digo de descuento.',
      copy: 'Copiar',
      copied: '\u00a1Copiado!',
      okApplied: 'Ya est\u00e1 aplicado a tu carrito: \u221225\u00a0% al pagar.',
      okAppliedAvant: 'Ya est\u00e1 aplicado a tu carrito: \u221210\u00a0% al pagar.',
      okManual: 'Introd\u00facelo al pagar.',
      okGift: '',
      okNote: 'V\u00e1lido en toda la tienda del 27 al 30 de noviembre, hasta las 23:59.',
      okNoteAvant: 'Apunta el 27 de\u00a0noviembre: \u221225\u00a0% en toda la tienda hasta el 30.',
      cont: 'Seguir comprando',
      close: 'Cerrar'
    },
    pl: {
      dialog: 'Black Friday: 25% zni\u017cki na ca\u0142y sklep',
      pct: '\u221225%',
      sub: 'Black Friday \u00b7 27\u201330\u00a0listopada',
      eyebrow: 'Black Friday trwa',
      eyebrowAvant: 'Black Friday tu\u017c-tu\u017c',
      title: '\u221225% na ca\u0142y sklep',
      titleAvant: '\u221210% ju\u017c teraz',
      text: 'Zostaw sw\u00f3j e-mail, a od razu zobaczysz kod na Black Friday.',
      textAvant: 'Zostaw sw\u00f3j e-mail, a od razu zobaczysz kod na 10% zni\u017cki. A od 27 do 30\u00a0listopada: \u221225% na ca\u0142y sklep.',
      label: 'Tw\u00f3j adres e-mail',
      placeholder: 'Tw\u00f3j adres e-mail',
      cta: 'Odbieram kod na Black Friday',
      ctaAvant: 'Odbieram 10% zni\u017cki',
      sending: 'Chwileczk\u0119\u2026',
      decline: 'Nie, dzi\u0119kuj\u0119',
      legal: 'Zapisuj\u0105c si\u0119, zgadzasz si\u0119 na otrzymywanie naszych e-maili z nowo\u015bciami i ofertami. Mo\u017cesz si\u0119 wypisa\u0107 jednym klikni\u0119ciem. Oferta wa\u017cna od 27 do 30 listopada 2026 r., do godz. 23:59.',
      legalAvant: 'Zapisuj\u0105c si\u0119, zgadzasz si\u0119 na otrzymywanie naszych e-maili z nowo\u015bciami i ofertami. Mo\u017cesz si\u0119 wypisa\u0107 jednym klikni\u0119ciem. Black Friday: \u221225% od 27 do 30 listopada 2026 r., do godz. 23:59.',
      privacy: 'Polityka prywatno\u015bci',
      errEmail: 'Ten adres e-mail wygl\u0105da na nieprawid\u0142owy.',
      errNetwork: 'Ups, co\u015b posz\u0142o nie tak. Spr\u00f3buj ponownie za chwil\u0119.',
      cdBefore: 'Black Friday za',
      cdDuring: 'Oferta ko\u0144czy si\u0119 za',
      units: ['dni', 'godz.', 'min', 'sek'],
      okTitle: 'Tw\u00f3j kod na Black Friday jest gotowy!',
      okTitleAvant: 'Tw\u00f3j kod rabatowy jest gotowy!',
      okText: 'Oto Tw\u00f3j kod rabatowy:',
      knownTitle: 'Ju\u017c jeste\u015b w naszej sieci!',
      knownText: 'Nie musisz si\u0119 zapisywa\u0107: oto Tw\u00f3j kod na Black Friday.',
      knownTextAvant: 'Nie musisz si\u0119 zapisywa\u0107: oto Tw\u00f3j kod rabatowy.',
      copy: 'Kopiuj',
      copied: 'Skopiowano!',
      okApplied: 'Kod jest ju\u017c aktywny w Twoim koszyku: \u221225% przy p\u0142atno\u015bci.',
      okAppliedAvant: 'Kod jest ju\u017c aktywny w Twoim koszyku: \u221210% przy p\u0142atno\u015bci.',
      okManual: 'Wpisz go przy p\u0142atno\u015bci.',
      okGift: '',
      okNote: 'Wa\u017cny w ca\u0142ym sklepie od 27 do 30 listopada, do godz. 23:59.',
      okNoteAvant: 'Zaznacz w kalendarzu 27\u00a0listopada: \u221225% na ca\u0142y sklep do 30\u00a0listopada.',
      cont: 'Kontynuuj zakupy',
      close: 'Zamknij'
    }
  };
  /* </T> */

  // --------------------------------------------------------------- styles (Shadow DOM)
  var CSS = [
    ':host{all:initial}',
    '*,*::before,*::after{box-sizing:border-box}',
    '[hidden]{display:none!important}',
    '.ov{--org:#e62429;--org2:#8a0f14;--org3:#b80000;--red:#e62429;--red2:#b80000;--blue:#0057b8;--pur:#121216;--ink:#10132b;--txt:#4a4f63;--mut:#7d8398;--line:#d9dce6;',
    'position:fixed;top:0;right:0;bottom:0;left:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;',
    'padding:24px;background:rgba(5,5,8,.74);-webkit-backdrop-filter:blur(3px);backdrop-filter:blur(3px);opacity:0;',
    'transition:opacity .28s ease;font-family:Outfit,"Helvetica Neue",Helvetica,Arial,sans-serif;font-size:16px;line-height:1.4;',
    'color:var(--ink);text-align:left;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;',
    'overscroll-behavior:contain;-webkit-tap-highlight-color:transparent}',
    '.ov.on{opacity:1}',
    '.dlg{position:relative;display:grid;grid-template-columns:42% 58%;width:100%;max-width:800px;',
    'max-height:calc(100vh - 48px);background:#fff;border-radius:18px;overflow:hidden;outline:none;',
    'box-shadow:0 30px 90px rgba(0,0,0,.55),0 0 0 1px rgba(230,36,41,.3);transform:translateY(16px) scale(.97);opacity:.4;',
    'transition:transform .34s cubic-bezier(.2,.8,.2,1),opacity .34s ease}',
    '.ov.on .dlg{transform:none;opacity:1}',
    /* panneau visuel : nuit du Black Friday */
    '.vis{position:relative;z-index:0;overflow:hidden;display:flex;flex-direction:column;justify-content:flex-end;',
    'min-height:470px;padding:34px 28px 120px;color:#fff;',
    'background:radial-gradient(75% 55% at 88% 8%,rgba(230,36,41,.5) 0%,rgba(230,36,41,0) 62%),',
    'radial-gradient(90% 70% at 0% 100%,rgba(0,87,184,.38) 0%,rgba(0,87,184,0) 62%),',
    'linear-gradient(170deg,#1d1d24 0%,#0d0d11 55%,#050507 100%)}',
    '.bf{position:absolute;top:30px;left:28px;z-index:0;margin:0;font-family:Archivo,"Arial Black",Impact,sans-serif;',
    'font-weight:800;font-size:40px;line-height:.9;letter-spacing:.02em;text-transform:uppercase;color:#fff!important;',
    'text-shadow:3px 3px 0 #e62429}',
    '.bf span{display:block}.bf span+span{color:transparent!important;-webkit-text-stroke:1.6px #fff;text-shadow:none}',
    '.web{position:absolute;top:-1px;left:-1px;width:520px;height:520px;color:#fff;opacity:.16;pointer-events:none;z-index:-1}',
    '.spider{position:absolute;top:0;left:44%;width:124px;z-index:0;pointer-events:none;',
    'animation:smbfSwing 4.5s ease-in-out infinite;transform-origin:50% 0}',
    '.spider i{display:block;width:2px;height:74px;margin-left:calc(61.1% - 1px);background:rgba(255,255,255,.8)}',
    '.spider img{display:block;width:100%;height:auto;margin-top:-6px;filter:drop-shadow(0 8px 12px rgba(0,0,0,.5))}',
    '.spider svg{display:block;width:46px;height:150px}',
    '@keyframes smbfSwing{0%,100%{transform:rotate(-4deg)}50%{transform:rotate(4deg)}}',
    '.band{position:absolute;left:-25%;right:-25%;bottom:-50px;height:132px;transform:rotate(-8deg);',
    'background:linear-gradient(90deg,#b80000,#e62429);box-shadow:0 -6px 0 rgba(0,0,0,.28);z-index:-1}',
    '.band::after{content:"";position:absolute;top:0;right:0;bottom:0;left:0;',
    'background-image:radial-gradient(rgba(255,255,255,.3) 1.3px,transparent 1.7px);background-size:9px 9px}',
    '.off{margin:0}',
    '.pct{display:inline-block;font-family:Archivo,"Arial Black",Impact,sans-serif;font-weight:700;font-size:86px;',
    'line-height:.92;letter-spacing:-.045em;white-space:nowrap;transform:skewX(-9deg);transform-origin:left bottom;',
    'color:#fff!important;text-shadow:4px 4px 0 #e62429,8px 8px 0 rgba(0,0,0,.35)}',
    '.sub{display:block;max-width:240px;margin-top:16px;font-size:13px;font-weight:700;line-height:1.35;',
    'letter-spacing:.14em;text-transform:uppercase;color:#ff6b6f!important}',
    /* panneau formulaire */
    '.bd{position:relative;z-index:0;display:flex;flex-direction:column;justify-content:center;',
    'padding:40px 40px 28px;overflow-x:hidden;overflow-y:auto;-webkit-overflow-scrolling:touch}',
    '.web2{position:absolute;right:0;bottom:0;width:300px;height:300px;transform:rotate(180deg);',
    'color:var(--blue);opacity:.07;pointer-events:none;z-index:-1}',
    '.eb{display:flex;align-items:center;gap:8px;margin:0 0 10px;font-size:12px;font-weight:800;line-height:1.3;letter-spacing:.16em;',
    'text-transform:uppercase;color:var(--red2)!important}',
    '.eb svg{flex:none;width:18px;height:18px}',
    '.title{margin:0 0 14px;font-family:Archivo,"Helvetica Neue",Arial,sans-serif;font-size:31px;font-weight:700;',
    'line-height:1.08;letter-spacing:-.01em;color:var(--ink)!important;outline:none}',
    '.text{margin:14px 0 18px;font-size:15.5px;line-height:1.5;color:var(--txt)!important}',
    /* compte à rebours */
    '.cd{margin:0}',
    '.cdl{margin:0 0 8px;font-size:12.5px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;color:var(--pur)!important}',
    '.cdg{display:grid;grid-template-columns:repeat(4,1fr);gap:8px}',
    '.cdc{display:flex;flex-direction:column;align-items:center;justify-content:center;padding:9px 4px 7px;border-radius:12px;',
    'background:linear-gradient(160deg,#26262e,#0c0c10);box-shadow:inset 0 0 0 1px rgba(230,36,41,.6)}',
    '.cdn{font-family:Archivo,"Helvetica Neue",Arial,sans-serif;font-size:24px;font-weight:700;line-height:1;color:#fff!important;',
    'font-variant-numeric:tabular-nums}',
    '.cdu{margin-top:4px;font-size:10.5px;font-weight:600;letter-spacing:.05em;text-transform:uppercase;color:rgba(255,255,255,.72)!important}',
    '.fm{position:relative;margin:0}',
    '.in{display:block;width:100%;height:54px;margin:0;padding:0 16px;border:2px solid var(--line);border-radius:12px;',
    'background:#fff;color:var(--ink);font:500 16px/1.2 Outfit,"Helvetica Neue",Arial,sans-serif;outline:none;',
    'box-shadow:none;-webkit-appearance:none;appearance:none;transition:border-color .15s,box-shadow .15s}',
    '.in::placeholder{color:#9aa0b4;opacity:1}',
    '.in:focus{border-color:var(--blue);box-shadow:0 0 0 4px rgba(0,87,184,.16)}',
    '.in[aria-invalid="true"]{border-color:#b80000;box-shadow:0 0 0 4px rgba(184,0,0,.12)}',
    '.cta{position:relative;display:flex;align-items:center;justify-content:center;gap:10px;width:100%;min-height:54px;',
    'margin:12px 0 0;padding:12px 20px;border:0;border-radius:12px;background:var(--red);color:#fff!important;',
    'font:700 16px/1.2 Outfit,"Helvetica Neue",Arial,sans-serif;letter-spacing:.06em;text-transform:uppercase;',
    'text-align:center;cursor:pointer;box-shadow:0 5px 0 var(--red2);-webkit-appearance:none;appearance:none;',
    'transition:transform .1s,box-shadow .1s,background-color .15s}',
    '.cta:hover{background:#f0262c}',
    '.cta:active{transform:translateY(3px);box-shadow:0 2px 0 var(--red2)}',
    '.cta:focus-visible,.copy:focus-visible,.no:focus-visible,.x:focus-visible,.legal a:focus-visible{outline:3px solid var(--blue);outline-offset:3px}',
    '.cta[disabled]{cursor:progress;opacity:.82;transform:none}',
    '.cta svg{flex:none;width:18px;height:18px}',
    '.err{margin:10px 0 0;font-size:14px;font-weight:600;line-height:1.4;color:#b80000!important}',
    '.err:empty{margin:0}',
    '.no{display:block;margin:12px auto 0;padding:6px 10px;border:0;background:none;color:var(--mut)!important;',
    'font:500 14px/1.3 Outfit,"Helvetica Neue",Arial,sans-serif;text-decoration:underline;text-underline-offset:3px;cursor:pointer}',
    '.no:hover{color:var(--ink)!important}',
    '.legal{margin:14px 0 0;font-size:11.5px;line-height:1.5;color:var(--mut)!important}',
    '.legal a{color:var(--blue)!important;text-decoration:underline;text-underline-offset:2px}',
    '.x{position:absolute;top:14px;right:14px;z-index:3;display:flex;align-items:center;justify-content:center;',
    'width:40px;height:40px;margin:0;padding:0;border:0;border-radius:50%;background:rgba(27,11,48,.07);',
    'color:var(--ink);cursor:pointer;transition:background-color .15s,transform .2s}',
    '.x:hover{background:rgba(27,11,48,.14);transform:rotate(90deg)}',
    '.x svg{width:18px;height:18px}',
    '.sr{position:absolute!important;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0}',
    '.hp{position:absolute!important;left:-9999px;top:0;width:1px;height:1px;overflow:hidden}',
    /* étape « code » */
    '.okic{display:flex;align-items:center;justify-content:center;width:56px;height:56px;margin:0 0 14px;border-radius:50%;',
    'background:var(--red);color:#fff;box-shadow:0 0 0 7px rgba(230,36,41,.14)}',
    '.okic svg{width:30px;height:30px}',
    '.code{display:flex;align-items:center;gap:12px;margin:4px 0 12px;padding:10px 10px 10px 18px;',
    'border:2px dashed var(--org);border-radius:14px;background:#fff1f1;animation:smbfPop .45s cubic-bezier(.2,.9,.3,1.35)}',
    '.codev{flex:1;min-width:0;font-family:Archivo,"Helvetica Neue",Arial,sans-serif;font-size:23px;font-weight:700;',
    'letter-spacing:.08em;line-height:1.2;color:var(--ink)!important;overflow-wrap:anywhere;-webkit-user-select:all;user-select:all}',
    '.copy{flex:none;min-height:44px;margin:0;padding:0 16px;border:0;border-radius:10px;background:var(--blue);color:#fff!important;',
    'font:700 14px/1 Outfit,"Helvetica Neue",Arial,sans-serif;letter-spacing:.05em;text-transform:uppercase;cursor:pointer;',
    'transition:background-color .15s}',
    '.copy.ok{background:#1d7d46}',
    '.hint{margin:0 0 4px;font-size:15px;line-height:1.5;color:var(--txt)!important}',
    '.gift{margin:0 0 4px;font-size:14px;font-weight:700;line-height:1.5;color:var(--red2)!important}',
    '.note{margin:0 0 14px;font-size:13px;line-height:1.5;color:var(--mut)!important}',
    '.s-ok .cd{margin:0 0 4px}',
    '.cta-cont{margin-top:16px}',
    '@keyframes smbfPop{from{transform:scale(.9);opacity:0}to{transform:none;opacity:1}}',
    /* téléphone : feuille qui monte du bas */
    '@media (max-width:719px){',
    '.ov{align-items:flex-end;padding:0;padding-bottom:var(--kb,0px)}',
    '.dlg{grid-template-columns:1fr;max-width:none;max-height:calc(100% - 12px);border-radius:22px 22px 0 0;transform:translateY(105%);opacity:1}',
    '.vis{min-height:0;flex-direction:row;align-items:center;justify-content:flex-start;padding:22px 64px 22px 22px}',
    '.off{display:flex;align-items:center;gap:16px}',
    '.pct{font-size:56px;text-shadow:3px 3px 0 #e62429,6px 6px 0 rgba(0,0,0,.3)}',
    '.sub{margin:0;max-width:150px;font-size:11.5px;letter-spacing:.12em}',
    '.bf{position:static;order:2;margin:0 0 0 12px;font-size:19px;line-height:.92;text-shadow:2px 2px 0 #e62429}.bf span+span{-webkit-text-stroke:1px #fff}',
    '.off{order:1}.sub{display:none}.spider{right:50px}',
    '.band,.web2{display:none}',
    '.spider{left:auto;right:58px;width:62px}.spider i{height:8px}.spider img{margin-top:-3px}',
    '.web{width:400px;height:400px}',
    '.x{top:12px;right:12px;background:rgba(255,255,255,.18);color:#fff}',
    '.x:hover{background:rgba(255,255,255,.3)}',
    '.bd{padding:20px 20px calc(16px + env(safe-area-inset-bottom,0px))}',
    '.title{font-size:24px;margin-bottom:10px}',
    '.text{margin:10px 0 12px;font-size:14.5px}',
    '.cdn{font-size:20px}.cdc{padding:7px 3px 5px}',
    '.cta{font-size:15px;letter-spacing:.02em;padding:12px 14px}',
    '.legal{margin-top:10px;font-size:11px}',
    '}',
    '@media (max-width:359px){.pct{font-size:46px}.title{font-size:22px}.bd{padding-left:16px;padding-right:16px}.vis{padding-left:16px}.cdn{font-size:18px}}',
    '@media (min-width:720px) and (max-height:660px){.vis{min-height:0;padding:24px 24px 100px}.pct{font-size:68px}',
    '.bd{padding:26px 34px 20px}.title{font-size:26px}.text{margin:10px 0 12px}.legal{margin-top:10px}}',
    '@media (prefers-reduced-motion:reduce){.ov,.dlg,.cta,.x,.copy{transition:none!important}.code,.spider{animation:none!important}.dlg{transform:none!important}}'
  ].join('');

  var ICON = {
    x: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    go: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12h14M13 6l6 6-6 6"/></svg>',
    // araignée Spidey : corps noir, yeux du masque (dessin original)
    spider: '<svg viewBox="0 0 32 32" aria-hidden="true" focusable="false"><g stroke="#121216" stroke-width="2" stroke-linecap="round" fill="none">' +
      '<path d="M11 13l-6-5-3 2M10 17H3l-2 3M11 21l-5 5 1 4M13 23l-2 6"/><path d="M21 13l6-5 3 2M22 17h7l2 3M21 21l5 5-1 4M19 23l2 6"/></g>' +
      '<ellipse cx="16" cy="18" rx="7" ry="8.5" fill="#121216"/><path d="M16 9.5v17M9 18h14" stroke="#e62429" stroke-width=".9"/>' +
      '<path d="M11.3 15.2c2.1-.6 4 .5 4.4 2.8-2.1 1.2-4.2.3-4.4-2.8zM20.7 15.2c-2.1-.6-4 .5-4.4 2.8 2.1 1.2 4.2.3 4.4-2.8z" fill="#fff" stroke="#e62429" stroke-width="1"/></svg>',
    ok: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>'
  };

  // Araignée suspendue aux yeux « masque » : dessin original (repli si l'image manque).
  function spiderSVG() {
    return '<svg viewBox="0 0 46 150" aria-hidden="true" focusable="false">' +
      '<line x1="23" y1="0" x2="23" y2="112" stroke="rgba(255,255,255,.55)" stroke-width="1.2"/>' +
      '<g stroke="#12061f" stroke-width="2.2" stroke-linecap="round" fill="none">' +
      '<path d="M15 118l-9-6-4 7M15 123l-11-1-3 7M16 128l-9 5-1 8M18 131l-5 8 2 7"/>' +
      '<path d="M31 118l9-6 4 7M31 123l11-1 3 7M30 128l9 5 1 8M28 131l5 8-2 7"/></g>' +
      '<ellipse cx="23" cy="124" rx="10.5" ry="12" fill="#b80000" stroke="#12061f" stroke-width="2"/>' +
      '<path d="M23 112v24M12.8 124h20.4" stroke="#12061f" stroke-width=".9" opacity=".55"/>' +
      '<path d="M15.5 120.5c2.6-.6 5 .6 5.6 3.4-2.6 1.4-5.2.3-5.6-3.4zM30.5 120.5c-2.6-.6-5 .6-5.6 3.4 2.6 1.4 5.2.3 5.6-3.4z" fill="#fff" stroke="#12061f" stroke-width="1.3"/></svg>';
  }

  // Spider-Man suspendu à sa toile devant la lune (image de la boutique, via la config).
  function spideyHTML() {
    var src = cfg.spidey ? String(cfg.spidey) : '';
    return '<span class="spider" aria-hidden="true">' + (src
      ? '<i></i><img src="' + esc(src) + '" alt="" width="124" height="132" decoding="async">'
      : spiderSVG()) + '</span>';
  }

  // --------------------------------------------------------------- état
  var cfg, t, params, mode, forced, dry, reduced, coarse;
  var state = 'closed';
  var host = null, root = null, els = {}, lastFocus = null, sending = false, downOnBackdrop = false;
  var prevHtmlOverflow = null, timer = null;

  try { boot(); } catch (err) { if (window.console) console.warn('[smbf]', err); }

  function boot() {
    cfg = readConfig();
    if (!cfg) return;
    if (!('attachShadow' in Element.prototype) || !window.fetch || !window.URLSearchParams || !window.Promise) return;
    appliquerPhase();
    params = new URLSearchParams(window.location.search);
    mode = String(params.get('smbf') || '').toLowerCase();
    forced = mode === 'show' || mode === 'test';
    var onLiveTheme = !!(window.Shopify && window.Shopify.theme && window.Shopify.theme.role === 'main');
    dry = !!cfg.designMode || (mode === 'test' && !onLiveTheme);
    reduced = mq('(prefers-reduced-motion: reduce)');
    coarse = mq('(pointer: coarse)');
    window.smbfPopup = { version: VERSION, open: function () { open({}); } };

    if (mode === 'reset') resetState();
    if (cfg.designMode) { setupEditor(); return; }
    if (!forced && ended()) return;

    // Arrivée depuis un e-mail marketing : abonné connu, le code s'affichera directement.
    if (/^e-?mail$/i.test(params.get('utm_medium') || '')) store(K.known, '1');

    var postedOk = params.get('customer_posted') === 'true';
    var postedExisting = !postedOk && params.get('form_type') === 'customer';
    if (sget(K.pending) === '1') {
      sdel(K.pending);
      if (postedOk || postedExisting) {
        store(K.got, '1');
        if (cfg.autoApply) applyCode();
        track('smbf_subscribe', { status: postedOk ? 'ok-verif' : 'existing-verif' });
        setTimeout(function () { open({ success: true }); }, 400);
        return;
      }
    }

    if (!forced && !eligible()) return;
    schedule();
  }

  function readConfig() {
    var el = document.getElementById('smbf-config');
    if (!el) return null;
    try {
      var c = JSON.parse(el.textContent || '{}');
      return c && typeof c === 'object' ? c : null;
    } catch (e) { return null; }
  }

  function langOf(c) { return String((c && c.locale) || 'fr').toLowerCase().split(/[-_]/)[0]; }
  function mq(q) { try { return window.matchMedia(q).matches; } catch (e) { return false; } }
  function finMs() { var v = Number(cfg.fin); return isFinite(v) && v > 0 ? v : 0; }
  function jourJMs() { var v = Number(cfg.jourJ); return isFinite(v) && v > 0 ? v : 0; }
  // Jour J atteint (ou pas de date) : phase Black Friday.
  function enCours() { var j = jourJMs(); return !j || Date.now() >= j; }
  // Avant le jour J : le code du moment (codeAvant) remplace le code Black Friday, et la mémoire est séparée :
  // qui a eu le code d'avant (ou a fermé le pop-up) le revoit le jour J, avec le code Black Friday.
  function appliquerPhase() {
    if (enCours()) return;
    if (String(cfg.codeAvant || '').trim()) cfg.code = cfg.codeAvant;
    K.got = 'smbf_got_avant';
    K.snooze = 'smbf_snooze_avant';
  }
  // Avant le jour J, chaque texte « xxxAvant » remplace « xxx ».
  function textesDuMoment(base) {
    if (enCours()) return base;
    var o = {}, k;
    for (k in base) if (Object.prototype.hasOwnProperty.call(base, k)) o[k] = base[k];
    for (k in base) if (Object.prototype.hasOwnProperty.call(base, k) && /Avant$/.test(k)) o[k.slice(0, -5)] = base[k];
    return o;
  }
  function ended() { return !!finMs() && Date.now() > finMs(); }

  // --------------------------------------------------------------- mémoire du navigateur
  function store(k, v) { try { window.localStorage.setItem(k, v); } catch (e) { cookieSet(k, v, 60); } }
  function load(k) {
    var v = null;
    try { v = window.localStorage.getItem(k); } catch (e) { /* stockage bloqué */ }
    return v !== null ? v : cookieGet(k);
  }
  function unstore(k) { try { window.localStorage.removeItem(k); } catch (e) { /* rien */ } cookieSet(k, '', -1); }
  function sget(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } }
  function sset(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) { /* rien */ } }
  function sdel(k) { try { window.sessionStorage.removeItem(k); } catch (e) { /* rien */ } }
  function cookieGet(k) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + k + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }
  function cookieSet(k, v, days) {
    try {
      document.cookie = k + '=' + encodeURIComponent(v) + '; path=/; max-age=' + Math.round(days * 86400) +
        '; SameSite=Lax' + (window.location.protocol === 'https:' ? '; Secure' : '');
    } catch (e) { /* rien */ }
  }
  function resetState() {
    ['smbf_got', 'smbf_snooze', 'smbf_got_avant', 'smbf_snooze_avant', K.known].forEach(unstore);
    [K.t0, K.shown, K.pending].forEach(sdel);
  }
  // Abonné connu : inscrit par le pop-up de bienvenue, arrivé d'un e-mail, ou client connecté abonné.
  function known() { return load(K.welcomeSub) === '1' || load(K.known) === '1' || cfg.known === true; }

  // --------------------------------------------------------------- qui voit le pop-up
  function eligible() {
    if (!cfg.enabled || !String(cfg.code || '').trim()) return false;
    if (ended()) return false;
    if (isBot()) return false;
    if (load(K.got) === '1') return false;
    if (sget(K.shown) === '1') return false;
    var until = parseInt(load(K.snooze) || '0', 10);
    if (until && Date.now() < until) return false;
    if (/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:account|challenge|password|policies|checkouts?)(?:[\/?#]|$)/i.test(window.location.pathname)) return false;
    return true;
  }

  function isBot() {
    return /googlebot|adsbot|storebot|google-inspectiontool|bingbot|bingpreview|yandex(?:bot|images|mobilebot)|baiduspider|duckduckbot|applebot|petalbot|ahrefsbot|semrushbot|mj12bot|dotbot|slurp|facebookexternalhit|facebot|twitterbot|linkedinbot|pinterestbot|embedly|crawler|spider|lighthouse|pagespeed|headlesschrome|bot\//i
      .test(navigator.userAgent || '');
  }

  function delayMs() {
    var d = Number(cfg.delay);
    if (!isFinite(d)) d = 10;
    return Math.min(Math.max(d, 0), 600) * 1000;
  }
  function reshowMs() {
    var d = Number(cfg.reshowDays);
    if (!isFinite(d) || d < 1) d = 4;
    return Math.min(d, 365) * 864e5;
  }

  function schedule() {
    var now = Date.now();
    var t0 = parseInt(sget(K.t0) || '', 10);
    if (!(t0 > 0) || t0 > now) {
      t0 = (window.performance && performance.timeOrigin) ? Math.round(performance.timeOrigin) : now;
      sset(K.t0, String(t0));
    }
    var wait = forced ? 1000 : Math.max(delayMs() - (now - t0), MIN_AFTER_LOAD);
    setTimeout(tryOpen, wait);
  }

  function tryOpen() {
    if (state !== 'closed') return;
    if (!forced && !eligible()) return;
    if (document.hidden) {
      var onVis = function () {
        if (document.hidden) return;
        document.removeEventListener('visibilitychange', onVis);
        setTimeout(tryOpen, 1500);
      };
      document.addEventListener('visibilitychange', onVis);
      return;
    }
    if (busy()) { setTimeout(tryOpen, RETRY_BUSY); return; }
    open({});
  }

  function busy() {
    var a = document.activeElement;
    if (a && a !== document.body) {
      if (a.isContentEditable || a.tagName === 'TEXTAREA' || a.tagName === 'SELECT') return true;
      if (a.tagName === 'INPUT' && !/^(button|submit|reset|checkbox|radio|range|color|file|image|hidden)$/i.test(a.type || '')) return true;
    }
    var b = document.body, h = document.documentElement;
    if (/(?:^|\s)(?:modal-open|js-drawer-open|overflow-hidden)(?:\s|$)/.test(b.className || '')) return true;
    try {
      if (getComputedStyle(b).overflowY === 'hidden' || getComputedStyle(h).overflowY === 'hidden') return true;
    } catch (e) { /* rien */ }
    return false;
  }

  // --------------------------------------------------------------- éditeur de thème
  function setupEditor() {
    var ours = function (e) {
      return !!e && ((e.detail && e.detail.sectionId === SECTION_ID) ||
        (e.target && e.target.id === 'shopify-section-' + SECTION_ID));
    };
    document.addEventListener('shopify:section:select', function (e) {
      if (!ours(e)) return;
      cfg = readConfig() || cfg; appliquerPhase();
      if (state !== 'closed') teardown();
      open({});
    });
    document.addEventListener('shopify:section:deselect', function (e) { if (ours(e)) close('editor'); });
    document.addEventListener('shopify:section:load', function (e) {
      if (!ours(e)) return;
      cfg = readConfig() || cfg; appliquerPhase();
      if (state !== 'closed') { teardown(); open({}); }
    });
  }

  // --------------------------------------------------------------- construction
  function esc(s) {
    return String(s == null ? '' : s).split('&').join('&amp;').split('<').join('&lt;').split('>').join('&gt;')
      .split('"').join('&quot;').split("'").join('&#39;');
  }

  function webSVG(cls, size) {
    var R = size, rays = 8, rings = 12, a = [], spokes = '', threads = '', i, j;
    var f = function (x) { return Math.round(x * 10) / 10; };
    for (i = 0; i < rays; i++) a.push(i / (rays - 1) * Math.PI / 2);
    for (i = 0; i < rays; i++) spokes += 'M0 0L' + f(R * 1.05 * Math.cos(a[i])) + ' ' + f(R * 1.05 * Math.sin(a[i]));
    for (j = 1; j <= rings; j++) {
      var r = R * Math.pow(j / rings, 1.12), sag = r * (j % 2 ? 0.935 : 0.95);
      for (i = 0; i < rays - 1; i++) {
        var m = (a[i] + a[i + 1]) / 2;
        threads += 'M' + f(r * Math.cos(a[i])) + ' ' + f(r * Math.sin(a[i])) +
          'Q' + f(sag * Math.cos(m)) + ' ' + f(sag * Math.sin(m)) + ' ' +
          f(r * Math.cos(a[i + 1])) + ' ' + f(r * Math.sin(a[i + 1]));
      }
    }
    return '<svg class="' + cls + '" viewBox="0 0 ' + R + ' ' + R + '" aria-hidden="true" focusable="false">' +
      '<path d="' + spokes + '" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>' +
      '<path d="' + threads + '" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>';
  }

  function countdownHTML(id) {
    var u = t.units;
    return '<div class="cd" aria-live="off">' +
      '<p class="cdl" id="' + id + '"></p>' +
      '<div class="cdg">' +
        '<span class="cdc"><span class="cdn" data-u="d">00</span><span class="cdu">' + esc(u[0]) + '</span></span>' +
        '<span class="cdc"><span class="cdn" data-u="h">00</span><span class="cdu">' + esc(u[1]) + '</span></span>' +
        '<span class="cdc"><span class="cdn" data-u="m">00</span><span class="cdu">' + esc(u[2]) + '</span></span>' +
        '<span class="cdc"><span class="cdn" data-u="s">00</span><span class="cdu">' + esc(u[3]) + '</span></span>' +
      '</div></div>';
  }

  function markup() {
    var code = String(cfg.code || '').trim();
    return '' +
      '<div class="ov" part="overlay">' +
        '<div class="dlg" role="dialog" aria-modal="true" aria-labelledby="smbf-t1" aria-describedby="smbf-d1" tabindex="-1">' +
          '<button type="button" class="x" aria-label="' + esc(t.close) + '">' + ICON.x + '</button>' +
          '<div class="vis">' + webSVG('web', 520) + '<p class="bf" aria-hidden="true"><span>Black</span><span>Friday</span></p>' + spideyHTML() +
            '<div class="band"></div>' +
            '<p class="off"><span class="pct">' + esc(t.pct) + '</span><span class="sub">' + esc(t.sub) + '</span></p>' +
          '</div>' +
          '<div class="bd">' + webSVG('web2', 300) +
            '<div class="s-form">' +
              '<p class="eb">' + ICON.spider + '<span>' + esc(t.eyebrow) + '</span></p>' +
              '<h2 class="title" id="smbf-t1">' + esc(t.title) + '</h2>' +
              countdownHTML('smbf-cd1') +
              '<p class="text" id="smbf-d1">' + esc(t.text) + '</p>' +
              '<form class="fm" novalidate>' +
                '<label class="sr" for="smbf-email">' + esc(t.label) + '</label>' +
                '<input class="in" id="smbf-email" type="email" name="contact[email]" required autocomplete="email" inputmode="email"' +
                  ' autocapitalize="off" autocorrect="off" spellcheck="false" enterkeyhint="send" aria-describedby="smbf-err"' +
                  ' placeholder="' + esc(t.placeholder) + '">' +
                '<div class="hp" aria-hidden="true"><input type="text" name="smbf_website" tabindex="-1" autocomplete="off"></div>' +
                '<button type="submit" class="cta cta-go"><span class="lbl">' + esc(t.cta) + '</span>' + ICON.go + '</button>' +
                '<p class="err" id="smbf-err" role="alert" aria-live="assertive"></p>' +
              '</form>' +
              '<button type="button" class="no">' + esc(t.decline) + '</button>' +
              '<p class="legal">' + esc(t.legal) + ' <a href="' + esc(cfg.privacyUrl || '/policies/privacy-policy') +
                '" target="_blank" rel="noopener">' + esc(t.privacy) + '</a></p>' +
            '</div>' +
            '<div class="s-ok" hidden>' +
              '<div class="okic">' + ICON.ok + '</div>' +
              '<h2 class="title" id="smbf-t2" tabindex="-1">' + esc(t.okTitle) + '</h2>' +
              '<p class="text" style="margin:0 0 10px">' + esc(t.okText) + '</p>' +
              '<div class="code"><span class="codev">' + esc(code) + '</span>' +
                '<button type="button" class="copy">' + esc(t.copy) + '</button></div>' +
              '<p class="hint">' + esc(cfg.autoApply ? t.okApplied : t.okManual) + '</p>' +
              (t.okGift ? '<p class="gift">' + esc(t.okGift) + '</p>' : '') +
              '<p class="note">' + esc(t.okNote) + '</p>' +
              countdownHTML('smbf-cd2') +
              '<button type="button" class="cta cta-cont">' + esc(t.cont) + '</button>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  function build() {
    destroyNow();
    t = textesDuMoment(T[langOf(cfg)] || T.en);
    host = document.createElement('div');
    host.id = 'smbf-host';
    // z-index maximal : au-dessus de la bulle du chatbot (chargée avant). Le défi hCaptcha, ajouté après, reste au-dessus.
    host.setAttribute('style', 'position:relative!important;z-index:2147483647!important;display:block!important;');
    root = host.attachShadow({ mode: 'open' });
    root.innerHTML = '<style>' + CSS + '</style>' + markup();
    document.body.appendChild(host);

    var $ = function (s) { return root.querySelector(s); };
    els = {
      ov: $('.ov'), dlg: $('.dlg'), form: $('.fm'), email: $('.in'), hp: $('.hp input'),
      go: $('.cta-go'), lbl: $('.cta-go .lbl'), err: $('.err'), stepForm: $('.s-form'), stepOk: $('.s-ok'),
      okTitle: $('#smbf-t2'), okText: $('.s-ok .text'), copy: $('.copy'), x: $('.x'), no: $('.no'), cont: $('.cta-cont')
    };
    if (cfg.email) els.email.value = String(cfg.email);

    els.ov.addEventListener('pointerdown', function (e) { downOnBackdrop = e.target === els.ov; });
    els.ov.addEventListener('click', function (e) {
      if (e.target === els.ov && downOnBackdrop) close('backdrop');
      downOnBackdrop = false;
    });
    els.x.addEventListener('click', function () { close('x'); });
    els.no.addEventListener('click', function () { close('decline'); });
    els.cont.addEventListener('click', function () { close('done'); });
    els.copy.addEventListener('click', copyCode);
    els.form.addEventListener('submit', onSubmit);
    els.email.addEventListener('input', function () {
      if (els.err.textContent) { els.err.textContent = ''; els.email.removeAttribute('aria-invalid'); }
    });
    tick();
  }

  // Compte à rebours : jusqu'au jour J (« Black Friday dans »), puis jusqu'à la fin de l'offre.
  function tick() {
    if (!root) return;
    var now = Date.now(), jj = jourJMs(), fin = finMs();
    var during = !!jj && now >= jj;
    var target = during ? fin : (jj || fin);
    var left = Math.max(0, target - now);
    var d = Math.floor(left / 864e5), h = Math.floor(left / 36e5) % 24, m = Math.floor(left / 6e4) % 60, s = Math.floor(left / 1e3) % 60;
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var label = during ? t.cdDuring : t.cdBefore;
    Array.prototype.forEach.call(root.querySelectorAll('.cdl'), function (n) { n.textContent = label; });
    Array.prototype.forEach.call(root.querySelectorAll('.cdn'), function (n) {
      var u = n.getAttribute('data-u');
      n.textContent = u === 'd' ? String(d) : pad(u === 'h' ? h : u === 'm' ? m : s);
    });
    if (fin && now > fin && state === 'open') { close('fin'); return; }
  }
  function startTicking() { stopTicking(); timer = setInterval(tick, 1000); }
  function stopTicking() { if (timer) { clearInterval(timer); timer = null; } }

  function destroyNow() {
    stopTicking();
    if (host && host.parentNode) host.parentNode.removeChild(host);
    host = null; root = null; els = {};
    state = 'closed';
  }

  function teardown() {
    document.removeEventListener('keydown', onKey, true);
    if (window.visualViewport) {
      window.visualViewport.removeEventListener('resize', onViewport);
      window.visualViewport.removeEventListener('scroll', onViewport);
    }
    unlockScroll();
    destroyNow();
  }

  // --------------------------------------------------------------- ouverture / fermeture
  function open(opts) {
    opts = opts || {};
    if (state !== 'closed' || !document.body) return;
    build();
    state = 'open';
    startTicking();
    if (!forced && !dry && !opts.success) sset(K.shown, '1');
    lastFocus = document.activeElement;
    lockScroll();
    document.addEventListener('keydown', onKey, true);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', onViewport);
      window.visualViewport.addEventListener('scroll', onViewport);
    }
    var direct = !opts.success && !cfg.designMode && known();
    if (opts.success) showSuccess(true, false);
    else if (direct) {
      // abonné déjà connu : pas d'e-mail à redemander, le code s'affiche tout de suite
      showSuccess(true, true);
      if (!dry) { store(K.got, '1'); if (cfg.autoApply) applyCode(); }
    }
    if (reduced) els.ov.classList.add('on');
    else requestAnimationFrame(function () { requestAnimationFrame(function () { if (els.ov) els.ov.classList.add('on'); }); });
    setTimeout(function () {
      if (state !== 'open') return;
      var target = (opts.success || direct) ? els.okTitle : (coarse ? els.dlg : els.email);
      try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); }
    }, reduced ? 0 : 80);
    track('smbf_view', { success: !!opts.success, direct: direct });
  }

  function close(reason) {
    if (state !== 'open') return;
    state = 'closing';
    if (!dry && reason !== 'editor' && reason !== 'fin' && load(K.got) !== '1') store(K.snooze, String(Date.now() + reshowMs()));
    document.removeEventListener('keydown', onKey, true);
    unlockScroll();
    if (els.ov) els.ov.classList.remove('on');
    var finish = function () {
      if (state !== 'closing') return;
      teardown();
      var f = lastFocus;
      lastFocus = null;
      if (f && f.focus && document.documentElement.contains(f)) {
        try { f.focus({ preventScroll: true }); } catch (e) { /* rien */ }
      }
    };
    if (reduced) finish(); else setTimeout(finish, 320);
    track('smbf_close', { reason: reason });
  }

  function lockScroll() {
    var h = document.documentElement;
    if (window.innerWidth - h.clientWidth > 0) return;
    prevHtmlOverflow = h.style.overflow;
    h.style.overflow = 'hidden';
  }
  function unlockScroll() {
    if (prevHtmlOverflow === null) return;
    document.documentElement.style.overflow = prevHtmlOverflow;
    prevHtmlOverflow = null;
  }

  function onViewport() {
    var vv = window.visualViewport;
    if (!vv || !els.ov) return;
    var kb = Math.round(window.innerHeight - vv.height - vv.offsetTop);
    els.ov.style.setProperty('--kb', (kb > 60 ? kb : 0) + 'px');
  }

  function focusables() {
    var list = els.dlg.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]):not([tabindex="-1"])');
    return Array.prototype.filter.call(list, function (n) { return n.offsetParent !== null; });
  }

  function onKey(e) {
    if (state !== 'open') return;
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); close('escape'); return; }
    if (e.key !== 'Tab') return;
    var list = focusables();
    if (!list.length) return;
    var first = list[0], last = list[list.length - 1], cur = root.activeElement;
    if (e.shiftKey && (cur === first || !cur || cur === els.dlg || cur === els.okTitle)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (cur === last || !cur)) { e.preventDefault(); first.focus(); }
  }

  // --------------------------------------------------------------- inscription
  function onSubmit(e) {
    e.preventDefault();
    if (sending) return;
    var email = String(els.email.value || '').trim();
    if (!EMAIL_RE.test(email)) { fail('email'); return; }
    if (els.hp.value) { succeed('hp'); return; }
    setSending(true);
    var slow = setTimeout(function () { setSending(false); }, 12000);
    (dry ? simulate(email) : send(email)).then(function (outcome) {
      clearTimeout(slow);
      handle(outcome, email);
    }, function () {
      clearTimeout(slow);
      handle('network', email);
    });
  }

  function handle(outcome, email) {
    setSending(false);
    if (outcome === 'ok' || outcome === 'existing' || outcome === 'unknown') { succeed(outcome); return; }
    if (state !== 'open') return;
    if (outcome === 'challenge') { nativeSubmit(email); return; }
    fail(outcome === 'invalid' ? 'email' : 'network');
  }

  function setSending(on) {
    sending = !!on;
    if (!els.go) return;
    els.go.disabled = sending;
    els.go.setAttribute('aria-busy', sending ? 'true' : 'false');
    els.lbl.textContent = sending ? t.sending : t.cta;
  }

  function fail(kind) {
    if (state !== 'open') return;
    els.err.textContent = kind === 'email' ? t.errEmail : t.errNetwork;
    if (kind === 'email') {
      els.email.setAttribute('aria-invalid', 'true');
      try { els.email.focus({ preventScroll: true }); } catch (e) { els.email.focus(); }
    }
  }

  function succeed(kind) {
    if (!dry) { store(K.got, '1'); store(K.welcomeSub, '1'); }
    if (!dry && cfg.autoApply && kind !== 'hp') applyCode();
    track('smbf_subscribe', { status: kind, simulated: dry });
    if (state === 'open') showSuccess(false, false);
  }

  function showSuccess(instant, direct) {
    els.stepForm.hidden = true;
    els.stepOk.hidden = false;
    if (direct) {
      els.okTitle.textContent = t.knownTitle;
      els.okText.textContent = t.knownText;
    }
    els.dlg.setAttribute('aria-labelledby', 'smbf-t2');
    els.dlg.removeAttribute('aria-describedby');
    tick();
    if (!instant) setTimeout(function () {
      if (state !== 'open') return;
      try { els.okTitle.focus({ preventScroll: true }); } catch (e) { els.okTitle.focus(); }
    }, 30);
  }

  function templateForm() {
    var tpl = document.getElementById('smbf-form-template');
    return tpl && tpl.content ? tpl.content.querySelector('form') : null;
  }

  var mirrors = 0;
  function makeMirror(email) {
    var src = templateForm();
    var f = document.createElement('form');
    f.id = 'smbf-mirror-' + (++mirrors);
    f.method = 'post';
    f.setAttribute('action', (src && src.getAttribute('action') ? src.getAttribute('action') : '/contact').split('#')[0]);
    f.setAttribute('accept-charset', 'UTF-8');
    f.setAttribute('aria-hidden', 'true');
    f.setAttribute('style', 'position:fixed!important;left:-10000px!important;top:0!important;width:1px!important;' +
      'height:1px!important;overflow:hidden!important;opacity:0!important;pointer-events:none!important;');
    var hidden = src ? src.querySelectorAll('input[type="hidden"]') : [];
    if (hidden.length) {
      Array.prototype.forEach.call(hidden, function (inp) {
        if (!inp.name) return;
        f.appendChild(Object.assign(document.createElement('input'), { type: 'hidden', name: inp.name, value: inp.value }));
      });
    } else {
      [['form_type', 'customer'], ['utf8', '\u2713'],
       ['contact[tags]', 'newsletter,pop-up email,pop-up email ' + langOf(cfg) + ',pop-up black friday']]
        .forEach(function (p) { f.appendChild(Object.assign(document.createElement('input'), { type: 'hidden', name: p[0], value: p[1] })); });
    }
    var em = Object.assign(document.createElement('input'), { type: 'hidden', name: 'contact[email]', value: email });
    em.setAttribute('value', email);
    f.appendChild(em);
    document.body.appendChild(f);
    return f;
  }

  function removeMirror(f) {
    if (f && f.parentNode) f.parentNode.removeChild(f);
  }

  function send(email) {
    return new Promise(function (resolve) {
      var settled = false, posted = false;
      var mirror = makeMirror(email);
      var finish = function (outcome) {
        if (settled) return;
        settled = true;
        removeMirror(mirror);
        resolve(outcome);
      };
      var ajax = function () {
        if (posted) return;
        posted = true;
        post(mirror).then(finish, function () { finish('network'); });
      };
      mirror.submit = ajax;   // Shopify appellera cette fonction une fois le jeton anti-robot ajouté
      var cap = window.Shopify && window.Shopify.captcha;
      if (cap && typeof cap.protect === 'function') {
        var bound = false;
        try {
          cap.protect(mirror, function () {
            bound = true;
            try { mirror.submit(); } catch (err) { ajax(); }
          });
        } catch (err) { ajax(); return; }
        setTimeout(function () { if (!bound) ajax(); }, 20000);
        setTimeout(function () { finish('timeout'); }, 120000);
      } else {
        ajax();
      }
    });
  }

  function post(form) {
    var body = new URLSearchParams();
    new FormData(form).forEach(function (v, k) { body.append(k, v); });
    var ctrl = window.AbortController ? new AbortController() : null;
    var tm = ctrl ? setTimeout(function () { ctrl.abort(); }, 25000) : null;
    return fetch(form.getAttribute('action'), {
      method: 'POST', body: body, credentials: 'same-origin', redirect: 'follow',
      headers: { Accept: 'text/html' }, signal: ctrl ? ctrl.signal : undefined
    }).then(function (res) {
      if (tm) clearTimeout(tm);
      var url = res.url || '';
      if (/\/challenge(?:[\/?#]|$)/.test(url)) return 'challenge';
      if (!res.ok) return 'http';
      return res.text().then(function (html) { return classify(url, html); }, function () { return classify(url, ''); });
    });
  }

  function classify(url, html) {
    var m = /data-smbf-state="(ok|error)"(?:\s+data-smbf-errors="([^"]*)")?/.exec(html || '');
    if (/[?&]customer_posted=true/.test(url) || (m && m[1] === 'ok')) return 'ok';
    if (m && m[1] === 'error') return /email/i.test(m[2] || '') ? 'invalid' : 'error';
    if (/[?&]form_type=customer/.test(url)) return 'existing';
    return 'unknown';
  }

  function nativeSubmit(email) {
    sset(K.pending, '1');
    var f = makeMirror(email);
    HTMLFormElement.prototype.submit.call(f);
  }

  function simulate(email) {
    return new Promise(function (resolve) {
      setTimeout(function () {
        resolve(/panne/i.test(email) ? 'http' : /erreur/i.test(email) ? 'invalid' : /existe/i.test(email) ? 'existing' : 'ok');
      }, 700);
    });
  }

  function applyCode() {
    var code = String(cfg.code || '').trim();
    if (!code) return;
    try {
      fetch('/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart.js'),
        { credentials: 'same-origin', headers: { Accept: 'application/json' } }).catch(function () { /* rien */ });
    } catch (e) { /* rien */ }
  }

  function copyCode() {
    var code = String(cfg.code || '').trim();
    var btn = els.copy;
    var done = function () {
      if (!btn) return;
      btn.textContent = t.copied;
      btn.classList.add('ok');
      track('smbf_copy', {});
      setTimeout(function () { if (btn) { btn.textContent = t.copy; btn.classList.remove('ok'); } }, 2200);
    };
    var legacy = function () {
      var ta = document.createElement('textarea');
      ta.value = code;
      ta.setAttribute('readonly', '');
      ta.setAttribute('style', 'position:fixed;top:-1000px;left:0;opacity:0;');
      document.body.appendChild(ta);
      ta.select();
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
      document.body.removeChild(ta);
      try { btn.focus({ preventScroll: true }); } catch (e) { /* rien */ }
      if (ok) done();
    };
    if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(code).then(done, legacy);
    else legacy();
  }

  function track(name, data) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        var payload = { locale: langOf(cfg), version: VERSION };
        for (var k in data) if (Object.prototype.hasOwnProperty.call(data, k)) payload[k] = data[k];
        window.Shopify.analytics.publish(name, payload);
      }
    } catch (e) { /* rien */ }
  }
})();
